"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileService = void 0;
var CommonService_decorator_1 = require("../../decorators/CommonService.decorator");
var Http_service_1 = require("../http/Http.service");
var JsonApi_service_1 = require("../jsonServiceApi/JsonApi.service");
var FileService = /** @class */ (function () {
    function FileService(jsonApiService, httpService) {
        this.jsonApiService = jsonApiService;
        this.httpService = httpService;
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    FileService.prototype.uploadFile = function (fileUploadInfo) {
        var _this = this;
        return this.jsonApiService.post('FileService', 'UploadFile', fileUploadInfo, {
            retryCallback: function () { return _this.uploadFile(fileUploadInfo); },
        });
    };
    FileService.prototype.getBlobData = function (blobId) {
        var _this = this;
        return this.jsonApiService.get('FileService', 'Blob', {
            query: { bid: blobId },
            retryCallback: function () { return _this.getBlobData(blobId); },
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    FileService.prototype.downloadCollaborationContent = function (data) {
        var _this = this;
        return this.jsonApiService.post('FileService', 'DownloadCollaborationContent', data, {
            retryCallback: function () { return _this.downloadCollaborationContent(data); },
        });
    };
    FileService.prototype.getArticleBlobData = function (downloadUrl) {
        var _this = this;
        return this.httpService.get(downloadUrl, {
            retryCallback: function () { return _this.getArticleBlobData(downloadUrl); },
        });
    };
    FileService = __decorate([
        CommonService_decorator_1.CommonService('FileService', { replaceAngularService: 'fileService' }),
        __metadata("design:paramtypes", [JsonApi_service_1.JsonApiService,
            Http_service_1.HttpService])
    ], FileService);
    return FileService;
}());
exports.FileService = FileService;
//# sourceMappingURL=File.service.js.map